import axios from '@/plugins/axios.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default {
    methods: {
        setQueryParams(chosen) {
            const url = new URL(window.location.href);
            url.searchParams.set(this.urlParam, chosen.map(item => item.id).join(','));
            window.history.pushState({}, ',', url);
        },

        removeQueryParams() {
            const url = new URL(window.location.href);
            url.searchParams.delete(this.urlParam);
            window.history.pushState({}, ',', url);
        },

        fillFromQueryParams() {
            const url = new URL(window.location.href);
            const ids = url.searchParams.get(this.urlParam);

            if (ids) {
                const queryBuilder = new QueryBuilder(this.endpoint);
                queryBuilder.filter('id', ids.split(','));

                axios.get(queryBuilder.toUrl()).then(response => {
                    this.selectedFromQuery = response.data.data;
                    this.$emit('save', response.data.data);
                });
            }
        },
    },
};
